/**
 * ProfileTooltip — small hover card that fetches /prochat/api/profile?u=<userid>
 * once and shows username, rank/title, memberfor, GT, played, overall rank.
 */
import { useEffect, useState } from 'react';
import { rankLabel } from '../lib/ranks.js';
import type { UserListEntry } from '../lib/types.js';

interface Props { user: UserListEntry; x: number; y: number; }

interface Profile {
    userid: number;
    username: string | null;
    title: string | null;
    memberfor: string | null;
    grandtotal: number | null;
    played: number | null;
    rank: number | null;
    avgrank: number | null;
}

const cache = new Map<number, Profile>();

export function ProfileTooltip({ user, x, y }: Props) {
    const [p, setP] = useState<Profile | null>(cache.get(user.id) ?? null);

    useEffect(() => {
        if (cache.has(user.id)) { setP(cache.get(user.id)!); return; }
        let cancelled = false;
        (async () => {
            try {
                const r = await fetch(`/prochat/api/profile?u=${user.id}`);
                if (!r.ok) return;
                const j = await r.json() as Profile;
                if (cancelled) return;
                cache.set(user.id, j);
                setP(j);
            } catch { /* ignore */ }
        })();
        return () => { cancelled = true; };
    }, [user.id]);

    return (
        <div className="profile-tip" style={{ top: y + 6, left: Math.max(x - 240, 8) }}>
            <div className="pt-hdr">
                {user.avatar && <img className="pt-avatar" src={user.avatar + '&cWidth=40&cHeight=40'} alt="" />}
                <div className="pt-name-wrap">
                    <div className="pt-name" style={{ color: user.color }}>{user.name}</div>
                    <div className="pt-rank">{p?.title || rankLabel(user.k)}</div>
                </div>
            </div>
            {p
                ? (
                    <div className="pt-stats">
                        {p.memberfor  && <div><span>Member for</span><b>{p.memberfor}</b></div>}
                        {p.grandtotal != null && <div><span>Grand Total</span><b>{p.grandtotal.toLocaleString()}</b></div>}
                        {p.played     != null && <div><span>Played</span><b>{p.played.toLocaleString()}</b></div>}
                        {p.rank       != null && <div><span>Rank</span><b>#{p.rank.toLocaleString()}</b></div>}
                    </div>
                )
                : <div className="pt-loading">loading…</div>}
        </div>
    );
}
